import { Controller } from "@hotwired/stimulus"

// Drives a feature paywall modal. Pro is the one paid tier since Growth folded
// into it (#3011); the tier machinery stays so a second tier can return
// without rework. Applies the default tier on connect, sets the
// title/subtitle/image, and the CTA label.
export default class extends Controller {
  static targets = [
    "proTab", "growthTab",
    "title", "subtitle",
    "proImage", "growthImage",
    "cta", "ctaLabel"
  ]

  static values = {
    defaultTier: { type: String, default: "pro" },
    trialUsed:   { type: Boolean, default: false }
  }

  connect() {
    this.currentTier = this.defaultTierValue === "growth" ? "growth" : "pro"
    this.applyTier(this.currentTier)
  }

  selectTier(event) {
    const tier = event.currentTarget.dataset.tier
    if (!tier) return
    this.applyTier(tier)
  }

  // Fires when the user clicks the "Upgrade to Pro/Growth" CTA. Tells the
  // plan controller on the upgrade modal which tier to pre-select; Bootstrap's
  // own data-bs-* handlers then close this modal and open #modal_upgrade_account.
  upgradeClick() {
    document.dispatchEvent(new CustomEvent("feature-paywall:select-tier", {
      detail: { tier: this.currentTier }
    }))
  }

  applyTier(tier) {
    const isGrowth = tier === "growth"
    this.currentTier = isGrowth ? "growth" : "pro"

    if (this.hasProTabTarget)    this.proTabTarget.classList.toggle("is-active", !isGrowth)
    if (this.hasGrowthTabTarget) this.growthTabTarget.classList.toggle("is-active", isGrowth)

    if (this.hasTitleTarget) {
      this.titleTarget.textContent = isGrowth
        ? this.titleTarget.dataset.growthTitle
        : this.titleTarget.dataset.proTitle
    }

    if (this.hasSubtitleTarget) {
      this.subtitleTarget.textContent = isGrowth
        ? this.subtitleTarget.dataset.growthSubtitle
        : this.subtitleTarget.dataset.proSubtitle
    }

    if (this.hasProImageTarget)    this.proImageTarget.classList.toggle("d-none", isGrowth)
    if (this.hasGrowthImageTarget) this.growthImageTarget.classList.toggle("d-none", !isGrowth)

    if (this.hasCtaLabelTarget) {
      if (this.trialUsedValue) {
        this.ctaLabelTarget.textContent = isGrowth ? "Upgrade to Growth" : "Upgrade to Pro"
      } else {
        this.ctaLabelTarget.textContent = "Try for Free"
      }
    }
  }
}
